import { AT_CHAT_DASHBOARD_SETTINGS_ACTION_SET, IChatDashboardSettingsActionSetAction } from './types';
import { TChatDashboardSettingsAction } from 'app/store/model/chatDashboardSettings/actions/types';

export const chatDashboardSettingsActionSet = (
    boardId: number,
    chatDashboardSettingsAction: TChatDashboardSettingsAction
): IChatDashboardSettingsActionSetAction => ({
    type: AT_CHAT_DASHBOARD_SETTINGS_ACTION_SET,
    boardId,
    chatDashboardSettingsAction
});
